import React, { Component, Fragment } from 'react';
import DataGrid, {
    Column,
    ColumnFixing, Export, Grouping,
    GroupPanel,
    HeaderFilter, Pager,
    Paging,
    SearchPanel,
    SortByGroupSummaryInfo,
    Sorting,
    StateStoring,
    Scrolling
} from 'devextreme-react/data-grid';
import DateBox from 'devextreme-react/date-box';
import moment from 'moment';
import { SelectBox } from 'devextreme-react/select-box';
import { getRequestParams, formatDate , getBaseApiUrl } from '../../helpers/globalfunctions.js';
import { LoadPanel } from 'devextreme-react/load-panel';
import secureLocalStorage from "react-secure-storage";
import { BasicMapStyle, RailMapStyle } from '../../helpers/mapstylejson';
import { NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import ReactApexChart from "react-apexcharts";
//import Progressbar from '../../helpers/progressBar.js';

const position = { of: '#historydiv' };

const DATEPICKER_FORMAT = "dd/MM/yyyy HH:mm";
const DISPLAY_DATETIME_FORMAT = "DD/MM/YYYY HH:mm";
const API_DATETIME_FORMAT = "YYYY-MM-DD HH:mm:ss";


const ANNTN_IGN_ON_BG = '#fff79c';
const ANNTN_STOPS_BG = '#a7ebfb';
const ANNTN_CONN_LOST_BG = '#e9e9e9';

const fuelActivityInfoWindow = {
    content: {
        width: '80%',
    }
}

export class FuelDashboardComponent extends Component {
    static displayName = FuelDashboardComponent.name;
    constructor(props) {
        super(props);
        this.mapRef = React.createRef();
        this.state = {
            url: sessionStorage.getItem("fuelAppUrl"),
            loadPanelVisible: false,
            center: {
                lat: 23.19835261391256,
                lng: 77.74196223222172
            },
            zoom: 5,
            dashboardData: [],
            filtereDashboardData: [],
            fuelActivityVehicleId: 0,
            fuelActivityVehicleNo: '',
            fuelActivityStartDate: '',
            fuelActivityEndDate: '',
            showFuelActivityDiv: false,
            fuelActivityData: [],
            series: [],
            chartOptions: {},
            fuelSensorList: [],
            fieldName: '',
            errors: {
                fieldName: '', fuelActivityVehicleId: '', fuelActivityDateRangeError: ''
            },
            xAnnotations: [],
            showIgnitionStatus: false,
            showStopsStatus: false,
            showConnectionLossStatus: false,
        }
        this.map = null;
        this.vehicleMarkers = [];
        this.fuelActivityMarkers = [];
        this.vehMarkerInfoWindow = null;
        this.activityMarkerInfoWindow = null;
    }
    async componentDidMount() {
        sessionStorage.setItem("session_PageName", "Fuel Dashboard");
        window.gtag('event', 'page_view', { page_title: sessionStorage.getItem("session_PageName"), page_location: window.location.pathname });
        //this.setState({ loadPanelVisible: true });
        this.map = new window.google.maps.Map(this.mapRef.current, {
            center: this.state.center,
            zoom: this.state.zoom
        });
        this.getFuelDashboardData();
    }

    getFuelDashboardData = async () => {
        try {
            let accountId = parseInt(secureLocalStorage.getItem('session_accountId'));
            let locationId = parseInt(secureLocalStorage.getItem('session_locationId'));
            let userId = parseInt(secureLocalStorage.getItem('session_userId'));
            const requestParams = getRequestParams('GET');
            this.setState({ loadPanelVisible: true });

            fetch(getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) + 'FuelActivity/GetFuelDashboardData/' + accountId + '/' + locationId + '/' + userId, requestParams)
                .then(response => { if (response.ok) return response.json() })
                .then(data => {
                    this.setState({ loadPanelVisible: false });
                    if (data != null) {
                        this.setState({
                            dashboardData: data.payload != null ? data.payload : [],
                            filtereDashboardData: data.payload != null ? data.payload : []
                        }, () => { this.drawVehicleMarkers() });
                    }
                });
        } catch (err) {
            console.log("Error in " + this.displayName + ".getFuelDashboardData function", err);
            this.setState({ loadPanelVisible: false });
        }
    }

    getMarkerIconUrl = (hostStatus, course, iconeName) => {
        let _course = course - (course % 5);
        let folderAndiconName = iconeName != '' ? iconeName : 'Car';
       //folderAndiconName = folderAndiconName == 'Excavator' ? 'Ex' : folderAndiconName;
        return "../assets/img/device-icons/" + folderAndiconName + "/" + folderAndiconName + "_" + this.getColorByHostStatus(hostStatus) +
            ((iconeName != "TrainEngine" && iconeName != "AcTrainEngine") ? ("_" + _course) : "") + ".png?v=1.4";
    }

    getColorByHostStatus = (hostStatus) => {
        let color = "";
        if (hostStatus === 0) {
            color = "orange";
        } else if (hostStatus === 1) {
            color = "green";
        } else if (hostStatus === 2) {
            color = "red";
        } else if (hostStatus === 3) {
            color = "orange";
        } else if (hostStatus === 4) {
            color = "blue";
        }
        return color;
    }

    drawVehicleMarkers = () => {
        try {
            for (let i = 0; i < this.vehicleMarkers.length; i++) {
                const marker = this.vehicleMarkers[i];
                marker.setMap(null);
            }
            this.vehicleMarkers = [];

            let bounds = new window.google.maps.LatLngBounds();
            var vehicles = this.state.dashboardData;
            for (let i = 0; i < vehicles.length; i++) {
                const vehicle = vehicles[i];
                let iconAnchor = (vehicle.vehicleIcon == "TrainEngine" && vehicle.vehicleIcon == "AcTrainEngine") ? 35 : 15;
                let latLng = new window.google.maps.LatLng(vehicle.latitude, vehicle.longitude);
                let iconImage = {
                    url: this.getMarkerIconUrl(vehicle.hostStatus, vehicle.course, vehicle.vehicleIcon),
                    origin: new window.google.maps.Point(0, 0),
                    anchor: new window.google.maps.Point(iconAnchor, iconAnchor),
                };
                let infoBoxDesc = "<div style='width:200px'><b>Vehicle # : </b>" + vehicle.vehicleNo + "<br/><b>Date Time: </b>" + moment(vehicle.deviceDateTime).format('DD-MMM HH:mm:ss') + "<br/><b>Fuel Level: </b>" + vehicle.fuelLevel + "<br /><b>Location : </b>" + vehicle.address + "</div>";
                let marker = new window.google.maps.Marker({
                    vehicleId: vehicle.vehicleId,
                    position: latLng,
                    map: this.map,
                    title: vehicle.vehicleNo,
                    icon: iconImage,
                    infoBoxDesc: infoBoxDesc
                });

                window.google.maps.event.addListener(marker, 'click', () => {
                    this.showVehicleLocInfoBox(marker);
                });

                this.vehicleMarkers.push(marker);
                bounds.extend(latLng);
            }
            if (!bounds.isEmpty()) {
                this.map.fitBounds(bounds);
            }
        } catch (err) {
            console.log("Error in " + this.displayName + ".drawVehicleMarkers function", err);
        }
    }

    getFuelActivityMarkerIconUrl = (status, course) => {
        let _course = course - (course % 5);
        if (status === 1) {
            return "../assets/img/device-icons/Direction/Direction_green_" + _course + ".png?v=1.0";
        } else if (status === 2) {
            return "../assets/img/device-icons/Direction/Direction_red_" + _course + ".png?v=1.0";
        } else if (status === 3) {
            return "../assets/img/device-icons/Direction/Direction_orange_" + _course + ".png?v=1.0";
        } else {
            return "../assets/img/device-icons/Direction/Direction_blue_" + _course + ".png?v=1.0";
        }
    }

    drawFuelActivityMarker = () => {
        try {
            for (let i = 0; i < this.fuelActivityMarkers.length; i++) {
                const marker = this.fuelActivityMarkers[i];
                marker.setMap(null);
            }
            this.fuelActivityMarkers = [];

            let bounds = new window.google.maps.LatLngBounds();
            var vehicles = this.state.fuelActivityData;
            for (let i = 0; i < vehicles.length; i++) {
                const vehicle = vehicles[i];
                let iconAnchor = 15;
                let latLng = new window.google.maps.LatLng(vehicle.latitude, vehicle.longitude);
                let iconImage = {
                    url: this.getFuelActivityMarkerIconUrl(vehicle.hostStatus, vehicle.course),
                    origin: new window.google.maps.Point(0, 0),
                    anchor: new window.google.maps.Point(iconAnchor, iconAnchor),
                };
                let fuelLevel = vehicle.fuelLevel.toString();

                let infoBoxDesc = "<div style='width:200px'><b>Vehicle # : </b>" + this.state.fuelActivityVehicleNo + "<br/><b>Date Time: </b>" + moment(vehicle.deviceDateTime).format('DD-MMM HH:mm:ss') + "<br/><b>Speed: </b>" + vehicle.speed + " kmph <br /><b>Fuel Level: </b>" + vehicle.fuelLevel + "<br /><b>Location : </b>" + vehicle.address + "</div>";

                let marker = new window.google.maps.Marker({
                    date: moment(vehicle.deviceDateTime).format(DISPLAY_DATETIME_FORMAT),
                    position: latLng,
                    map: this.map,
                    title: fuelLevel,
                    icon: iconImage,
                    infoBoxDesc: infoBoxDesc
                });

                window.google.maps.event.addListener(marker, 'click', () => {
                    this.showActivityInfoBox(marker);
                });
                this.fuelActivityMarkers.push(marker);
                bounds.extend(latLng);
            }
            if (!bounds.isEmpty()) {
                this.map.fitBounds(bounds);
            }
        } catch (err) {
            console.log("Error in " + this.displayName + ".drawFuelActivityMarker function", err);
        }
    }

    handleShowVehicleFuelDetails = (data) => {
        if (this.vehMarkerInfoWindow != null) { this.vehMarkerInfoWindow.close(); }
        if (this.activityMarkerInfoWindow != null) { this.activityMarkerInfoWindow.close(); }

        let vehicleId = data.vehicleId;
        for (let i = 0; i < this.vehicleMarkers.length; i++) {
            let marker = this.vehicleMarkers[i];
            marker.setVisible(false);
        }
        let sDate = moment(data.deviceDateTime).startOf('day').format(API_DATETIME_FORMAT);
        let eDate = moment(data.deviceDateTime).format(API_DATETIME_FORMAT);

        let startDate = moment(moment(sDate).format(DISPLAY_DATETIME_FORMAT), DISPLAY_DATETIME_FORMAT).toDate();
        let endDate = moment(moment(eDate).format(DISPLAY_DATETIME_FORMAT), DISPLAY_DATETIME_FORMAT).toDate();

        this.setState({ fuelActivityVehicleNo: data.vehicleNo, fuelActivityVehicleId: vehicleId, fuelActivityStartDate: startDate, fuelActivityEndDate: endDate, fieldName: 'fuelLevel' }, () => {
            this.handleGetFuelSensors();
            this.getVehicleFuelActivity(sDate, eDate);
        });
    }

    handleZoomVehicle = (data) => {
        this.setState({
            zoom: this.map.getZoom() < 25 ? 25 : this.map.getZoom(),
            center: {
                lat: data.latitude,
                lng: data.longitude
            },
        }, () => {
            this.map.setCenter(this.state.center);
            this.map.setZoom(this.state.zoom);
            if (this.vehicleMarkers != null) {
                let marker = this.vehicleMarkers.filter(f => f.vehicleId == data.vehicleId) != null ? this.vehicleMarkers.filter(f => f.vehicleId == data.vehicleId)[0] : null;
                if (marker != null) {
                    this.showVehicleLocInfoBox(marker);
                }
            }
        });
    }

    handleZoomVehicleAddress = (data) => {
        this.setState({
            zoom: this.map.getZoom() < 25 ? 25 : this.map.getZoom(),
            center: {
                lat: data.data.latitude,
                lng: data.data.longitude
            },
        }, () => {
            this.map.setCenter(this.state.center);
            this.map.setZoom(this.state.zoom);
            if (this.fuelActivityMarkers != null) {
                let deviceDatetime = moment(data.data.deviceDateTime).format(DISPLAY_DATETIME_FORMAT);
                let list = this.fuelActivityMarkers.filter(f => f.date == deviceDatetime);
                let marker = list != null ? list[0] : null;
                if (marker != null) {
                    this.showActivityInfoBox(marker);
                }
            }
        });
    }

    handleGetFuelSensors = () => {
        try {
            //this.setState({ loadPanelVisible: true });
            const requestParams = getRequestParams('GET');
            fetch(getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) + 'VehicleSensor/GetFuelSensors/' + this.state.fuelActivityVehicleId + '/' + false, requestParams)
                .then(response => { if (response.ok) return response.json() })
                .then(data => {
                    //this.setState({ loadPanelVisible: false });
                    if (data != null) {
                        this.setState({
                            fuelSensorList: data.payload != null ? data.payload : [],
                        });
                    }
                });
        } catch (err) {
            // this.setState({ loadPanelVisible: false });
            console.log("Error in " + this.displayName + ".handleGetFuelSensors function", err);
        }
    }

    getVehicleFuelActivity = (sdate, eDate) => {
        try {
            let errors = this.state.errors;
            errors.fieldName = '';
            errors.fuelActivityVehicleId = '';
            errors.fuelActivityDateRangeError = '';
            if (this.state.fieldName === '') {
                errors.fieldName = "Please select sensor.";
                this.setState({ errors: errors });
                return false;
            }
            if (this.state.fuelActivityVehicleId === 0) {
                errors.fuelActivityVehicleId = "Please select vehicle.";
                this.setState({ errors: errors });
                return false;
            }
            var isBefore = moment(eDate).isBefore(moment(sdate));
            if (isBefore) {
                errors.fuelActivityDateRangeError = "Start date should be greater then end date.";
                this.setState({ errors: errors });
                return false;
            }

            var hourDiff = moment(eDate).diff(moment(sdate), 'hour');
            if (hourDiff > 48) {
                errors.fuelActivityDateRangeError = "The date time range should not be more than 48 hours.";
                this.setState({ errors: errors });
                return false;
            }

            this.setState({ loadPanelVisible: true, showIgnitionStatus: false, showStopsStatus: false, showConnectionLossStatus: false });
            const requestParams = getRequestParams('GET');
            fetch(getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) + 'FuelActivity/' + this.state.fuelActivityVehicleId + '/' + sdate + "/" + eDate + "/" + this.state.fieldName, requestParams)
                .then(response => { if (response.ok) return response.json() })
                .then(data => {
                    this.setState({ showFuelActivityDiv: true, loadPanelVisible: false });
                    if (data != null) {
                        this.setState({
                            fuelActivityData: data.payload != null ? data.payload : [],
                        }, () => {
                            this.drawFuelActivityMarker();
                            this.bindChart(data);
                        });


                    }

                });
        } catch (err) {
            this.setState({ loadPanelVisible: false });
            console.log("Error in " + this.displayName + ".getVehicleFuelActivity function", err);
        }
    }

    bindChart = (data) => {
        let list = [];
        let xAnnotations = [];
        let points = [];
        let prevIgnitionStatus = false;
        let ignitionStartTime = null;
        let ignitionOffTime = null;

        let prevStatus = 1;  //1-moving and 2-stop
        let vehicleStartTime = null;
        let vehicleStopTime = null;

        let prevConnectionStatus = 1;
        let connectionLossTime = null;
        let connectionRetriveTime = null;

        let fuelActivityData = data.payload != null ? data.payload : [];
        data.payload != null && data.payload.map((item, i) => {
            list.push({
                "id": i,
                "deviceDateTime": item.deviceDateTime,
                "fuelLevel": item.fuelLevel,
                "avgFuelLevel": item.avgFuelLevel,
            })

            //#region ignition
            if (item.ignitionStatus === true && prevIgnitionStatus === false) {
                ignitionStartTime = item.deviceDateTime;
            }
            if (item.ignitionStatus === false && ignitionStartTime !== null) {
                ignitionOffTime = item.deviceDateTime;
                xAnnotations.push({
                    x: moment(ignitionStartTime).format("DD-MM HH:mm"),
                    x2: moment(ignitionOffTime).format("DD-MM HH:mm"),
                    GridName: 'ignitionStatus',
                    borderColor: 'transparent',
                    fillColor: ANNTN_IGN_ON_BG,
                    opacity: 0.9,
                });
                //ignitionStartTime = null; ignitionOffTime = null;
            } else {
                if (ignitionStartTime !== null && data.payload.length - 1 == i) {
                    xAnnotations.push({
                        x: moment(ignitionStartTime).format("DD-MM HH:mm"),
                        x2: moment(item.deviceDateTime).format("DD-MM HH:mm"),
                        GridName: 'ignitionStatus',
                        borderColor: 'transparent',
                        fillColor: ANNTN_IGN_ON_BG,
                        opacity: 0.9,
                        label: {
                            //show: false,
                            // borderColor: '#B3F7CA',
                            // style: {
                            //     fontSize: '10px',
                            //     color: '#fff',
                            //     background: '#00E396',
                            // },
                            //offsetY: -10,
                            //text: 'Ignition - ON',
                        }
                    });
                }
            }

            prevIgnitionStatus = item.ignitionStatus;
            //#endregion

            //#region stop
            if (item.hostStatus === 2 && prevStatus === 1) {
                vehicleStopTime = item.deviceDateTime;
            }
            if (item.hostStatus === 1 && vehicleStopTime !== null) {
                vehicleStartTime = item.deviceDateTime;
                xAnnotations.push({
                    x: moment(vehicleStopTime).format("DD-MM HH:mm"),
                    x2: moment(vehicleStartTime).format("DD-MM HH:mm"),
                    GridName: 'stops',
                    borderColor: 'transparent',
                    fillColor: ANNTN_STOPS_BG,
                    opacity: 0.9,
                });
            } else {
                if (vehicleStopTime !== null && data.payload.length - 1 == i) {
                    xAnnotations.push({
                        x: moment(vehicleStopTime).format("DD-MM HH:mm"),
                        x2: moment(item.deviceDateTime).format("DD-MM HH:mm"),
                        GridName: 'stops',
                        borderColor: 'transparent',
                        fillColor: ANNTN_STOPS_BG,
                        opacity: 0.9,
                    });
                }
            }

            prevStatus = item.hostStatus;
            //#endregion

            //#region connectionLoss
            if (item.fuelLevel === -0.01 && prevConnectionStatus !== -0.01) {
                connectionLossTime = item.deviceDateTime;
            }
            if (item.fuelLevel !== -0.01 && connectionLossTime !== null) {
                connectionRetriveTime = item.deviceDateTime;
                xAnnotations.push({
                    x: moment(connectionLossTime).format("DD-MM HH:mm"),
                    x2: moment(connectionRetriveTime).format("DD-MM HH:mm"),
                    GridName: 'connectionLoss',
                    borderColor: 'transparent',
                    fillColor: ANNTN_CONN_LOST_BG,
                    opacity: 0.9,
                });
                // connectionLossTime = null; connectionRetriveTime = null;
            } else {
                if (connectionLossTime !== null && data.payload.length - 1 == i) {
                    xAnnotations.push({
                        x: moment(connectionLossTime).format("DD-MM HH:mm"),
                        x2: moment(item.deviceDateTime).format("DD-MM HH:mm"),
                        GridName: 'connectionLoss',
                        borderColor: 'transparent',
                        fillColor: ANNTN_CONN_LOST_BG,
                        opacity: 0.9,
                    });
                }
            }

            prevConnectionStatus = item.fuelLevel;
            //#endregion

            //#region fuelStatus
            if (item.fuelEvent !== null) {
                let icon = '../assets/img/fuel/Fuel_refill.png';
                let color = 'green';
                let text = 'refill - ' + item.fuelLevel;
                if (item.fuelEvent !== 'refill') {
                    icon = '../assets/img/fuel/Fuel_drain.png';
                    color = 'red'; text = 'drain - ' + item.fuelLevel;
                }
                points.push({
                    x: moment(item.deviceDateTime).format("DD-MM HH:mm"),
                    y: item.fuelLevel,
                    marker: {
                        size: 0
                    },
                    image: {
                        path: icon
                    }
                })

                xAnnotations.push({
                    x: moment(item.deviceDateTime).format("DD-MM HH:mm"),
                    //fillColor: '#B3F7CA',
                    borderColor: color,
                    GridName: 'fuelRefillOrDrain',
                    label: {
                        style: {
                            background: color,
                            color: '#fff',
                        },
                        text: text
                    }
                });
            }
            //#endregion
        })
        this.setState({ xAnnotations: xAnnotations });
        let avgFuelLevel = list?.map((item) => item.avgFuelLevel);
        let fuelLevel = list?.map((item) => item.fuelLevel);
        let xAxisLabels = list?.map((item) => moment(item.deviceDateTime).format("DD-MM HH:mm"));
        let series = [];
        series.push({
            name: "Fuel",
            data: fuelLevel
        })
        series.push({
            name: "Avg Fuel",
            data: avgFuelLevel,
            // fill: {
            //     colors: 'red',
            // }
        })
        let chartOptions = this.state.chartOptions;

        chartOptions = {
            chart: {
                id: 'bar-chart',
                events: {
                    markerClick:  (event, chartContext, config) => {
                        let index = chartContext.w.globals.capturedDataPointIndex;
                        let value = chartContext.w.globals.categoryLabels[index];
                        this.handleOnChartClick(value);
                    }
                }
            },
            type: 'line',

            colors: ['#0099ff', '#ff3300'],
            stroke: {
                width: 2,
                curve: 'smooth',
                // OR provide an array
                curve: ['smooth', 'straight', 'stepline']
            },
            labels: xAxisLabels,
            annotations: {
                xaxis: xAnnotations.filter(f => f.GridName == "fuelRefillOrDrain"),
                points: points,
            },

            xaxis: {
                type: 'datetime',
                labels: {
                    hideOverlappingLabels: true,
                    // showDuplicates: false,
                    // formatter: function (value) {
                    //     var hr = moment(value).format('HH:mm');
                    //     return hr;
                    //   },
                    showDuplicates: false,
                }

            },
            yaxis: {
                type: 'numeric',
                labels: {
                    show: true,
                    floating: true,
                    // formatter: (value) => {
                    //     return parseFloat(value).toFixed(0)
                    // },
                }
            },
            dataLabels: {
                enabled: false
            },

        }

        this.setState({
            series: series,
            chartOptions: chartOptions
        });
    }

    handleOnChartClick = (date) => {
        if (this.fuelActivityMarkers != null) {
            let markers = this.fuelActivityMarkers.filter(f => moment(moment(f.date,DISPLAY_DATETIME_FORMAT)).format("DD-MM HH:mm") == date);
            if (markers.length > 0) {
                let marker = markers[0];
                this.showActivityInfoBox(marker);
            }
        }
    }
    handleHideFuelActivityDiv = (e, data) => {
        let bounds = new window.google.maps.LatLngBounds();
        for (let i = 0; i < this.vehicleMarkers.length; i++) {
            let marker = this.vehicleMarkers[i];
            marker.setVisible(true);
            bounds.extend(marker.position);
        }
        for (let i = 0; i < this.fuelActivityMarkers.length; i++) {
            const marker = this.fuelActivityMarkers[i];
            marker.setMap(null);
        }
        this.fuelActivityMarkers = [];
        this.map.setCenter(this.state.center);
        this.map.setZoom(this.state.zoom);
        if (!bounds.isEmpty()) {
            this.map.fitBounds(bounds);
        }

        if (this.activityMarkerInfoWindow != null) { this.activityMarkerInfoWindow.close(); }
        if (this.vehMarkerInfoWindow != null) { this.vehMarkerInfoWindow.close(); }

        this.setState({
            showFuelActivityDiv: false, fuelActivityData: [], fuelActivityVehicleNo: '', fuelActivityVehicleId: 0, chartOptions: {}, series: [],
            fuelActivityStartDate: '', fuelActivityEndDate: '', fieldName: '', fuelSensorList: [], errors: { fieldName: '', fuelActivityVehicleId: '', fuelActivityDateRangeError: '' }, xAnnotations: [], showIgnitionStatus: false, showStopsStatus: false, showConnectionLossStatus: false,
        });
    }

    handleOnSearchVehicleFuelActivity = () => {
        let sDate = moment(this.state.fuelActivityStartDate).format(API_DATETIME_FORMAT);
        let eDate = moment(this.state.fuelActivityEndDate).format(API_DATETIME_FORMAT);
        this.getVehicleFuelActivity(sDate, eDate);
    }

    handleIgnitionEvent = async (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        let list = [];
        list = this.state.xAnnotations.filter(f => f.GridName == "fuelRefillOrDrain");

        if (value) {
            let ignitionList = this.state.xAnnotations.filter(g => g.GridName == 'ignitionStatus');
            ignitionList.map((item) => {
                item.fillColor = "#ffffe6"; item.border = 'none'  // item.borderColor = "#000000"
            })
            list = list.concat(ignitionList);
        }
        if (this.state.showStopsStatus) {
            let stopList = this.state.xAnnotations.filter(g => g.GridName == 'stops');
            list = list.concat(stopList);
        }
        if (this.state.showConnectionLossStatus) {
            let connectionLossList = this.state.xAnnotations.filter(g => g.GridName == 'connectionLoss');
            list = list.concat(connectionLossList);
        }
        this.setState({
            showIgnitionStatus: value, chartOptions: {
                annotations: {
                    xaxis: list
                },
            }
        });

    }

    handleStopsEvent = async (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        let list = [];
        list = this.state.xAnnotations.filter(f => f.GridName == "fuelRefillOrDrain");

        if (value) {
            let stioList = this.state.xAnnotations.filter(g => g.GridName == 'stops');
            stioList.map((item) => {
                item.fillColor = "#ccebff"; item.border = 'none'  //item.borderColor = "#000000"
            });
            list = list.concat(stioList);
        }
        if (this.state.showIgnitionStatus) {
            let ignitionList = this.state.xAnnotations.filter(g => g.GridName == 'ignitionStatus');
            list = list.concat(ignitionList);
        }
        if (this.state.showConnectionLossStatus) {
            let connectionLossList = this.state.xAnnotations.filter(g => g.GridName == 'connectionLoss');
            list = list.concat(connectionLossList);
        }

        this.setState({
            showStopsStatus: value, chartOptions: {
                annotations: {
                    xaxis: list
                },
            }
        });

    }

    handleConnectionLossEvent = async (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        let list = [];
        list = this.state.xAnnotations.filter(f => f.GridName == "fuelRefillOrDrain");

        if (value) {
            let connectionLossList = this.state.xAnnotations.filter(g => g.GridName == 'connectionLoss');
            connectionLossList.map((item) => {
                item.fillColor = "#e0e0d2"; item.border = 'none'  // item.borderColor = "#000000"
            })
            list = list.concat(connectionLossList);
        }
        if (this.state.showIgnitionStatus) {
            let ignitionList = this.state.xAnnotations.filter(g => g.GridName == 'ignitionStatus');
            list = list.concat(ignitionList);
        }
        if (this.state.showStopsStatus) {
            let stopList = this.state.xAnnotations.filter(g => g.GridName == 'stops');
            list = list.concat(stopList);
        }
        this.setState({
            showConnectionLossStatus: value, chartOptions: {
                annotations: {
                    xaxis: list
                },
            }
        });

    }

    handleOnFuelSensorChange = (e) => {
        let errors = this.state.errors;
        errors.fieldName = '';
        this.setState({
            fieldName: (e.selectedItem != null ? e.selectedItem.fieldName : ''),
            errors: errors
        });
    }

    handleOnFuelActivityVehChange = (e) => {
        let errors = this.state.errors;
        errors.fuelActivityVehicleId = '';
        this.setState({
            fuelActivityVehicleId: (e.selectedItem != null ? e.selectedItem.vehicleId : 0),
            fuelActivityVehicleNo: (e.selectedItem != null ? e.selectedItem.vehicleNo : ''),
            errors: errors
        });
    }

    handleFuelGridRowPrepared(e) {
        if (e.rowType == 'data') {
            if (e.data.fuelEvent === 'refill') {
                e.rowElement.style.backgroundColor = '#bdffa2';
            } else if (e.data.fuelEvent === 'drop') {
                e.rowElement.style.backgroundColor = '#ffc5c5';
            }
        }
    }

    handleFuelActivityStartDateChanged = (date) => {
        let errors = this.state.errors;
        errors.fuelActivityDateRangeError = '';
        this.setState({ fuelActivityStartDate: date.value, errors: errors });
    };

    handleFuelActivityEndDateChanged = (date) => {
        let errors = this.state.errors;
        errors.fuelActivityDateRangeError = '';
        this.setState({ fuelActivityEndDate: date.value, errors: errors });
    };

    showVehicleLocInfoBox = (marker) => {
        if (this.vehMarkerInfoWindow != null)
            this.vehMarkerInfoWindow.close();

        this.vehMarkerInfoWindow = new window.google.maps.InfoWindow({
            content: marker.infoBoxDesc
        });
        this.vehMarkerInfoWindow.open(this.map, marker);
    }

    showActivityInfoBox = (marker) => {
        if (this.activityMarkerInfoWindow != null)
            this.activityMarkerInfoWindow.close();

        this.activityMarkerInfoWindow = new window.google.maps.InfoWindow({
            content: marker.infoBoxDesc
        });
        this.activityMarkerInfoWindow.open(this.map, marker);
        this.map.setCenter(marker.position);
        this.map.setZoom(20);   

    }

    renderStatusColor = (hostStatus) => {
        if (hostStatus === 1) {
            return '#8cd98c';
        } else if (hostStatus === 2) {
            return '#ff8080';
        } else if (hostStatus === 3) {
            return '#ffc966';
        } else if (hostStatus === 4) {
            return 'gray';
        } else {
            return 'gray';
        }
    }

    renderGridStatusCell = (hostStatus) => {
        if (hostStatus === 1) {
            return 'Moving';
        } else if (hostStatus === 2) {
            return 'Stopped';
        } else if (hostStatus === 3) {
            return 'Idle';
        } else if (hostStatus === 4) {
            return 'Out Of Service';
        } else {
            return 'Out Of Service';
        }
    }

    // renderGridFuelLevelCell = (data) => {
    //     var fuelPer = data.fuelLevelPct
    //     //let fuelPer = Number(fuelLevelPct.replaceAll("%",""));
    //     let bgcolor = '#8ee189';
    //     if (fuelPer <= 10) {
    //         bgcolor = '#eb6d64';
    //     } else if (fuelPer > 10 && fuelPer < 20) {
    //         bgcolor = '#ff9800';
    //     }
    //     let title = 'Fuel - ' + data.fuelLevel;
    //     return <div title={title}>
    //         <Progressbar bgcolor={bgcolor} progress={data.fuelLevelPct} height={30} />
    //     </div>
    // }

    handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const inputValue = target.value;
        const name = target.name;

        if (value.trim() != "") {
            var textFilterArray = this.state.dashboardData.filter(f => f.vehicleNo.toUpperCase().includes(value.trim().toUpperCase()));
            this.setState({
                filtereDashboardData: textFilterArray,
            });
        }
        else {
            this.setState({
                filtereDashboardData: this.state.dashboardData
            });
        }

        this.setState({ [name]: value });

    }

    render() {
        const renderGridAddressCell = (data) => {
            return <div>
                <NavLink tag={Link} to="#" style={{ textDecoration: 'underline', padding: 0, cursor: 'pointer' }} title='Zoom' onClick={(e) => { this.handleZoomVehicleAddress(data) }} >{data.data.address}</NavLink>
            </div>;
        }

        return (
            <Fragment>
                <div className="card">
                    <div className="card-body">
                        <div className="section-body">
                            <div style={{ display: this.state.showFuelActivityDiv ? 'block' : 'none', backgroundColor: '#f9f9f9', padding: '7px' }}>
                                <div className="pull-left" style={{ width: '150px' }}>
                                    <div className="form-group">
                                        <label>Select Vehicle</label>
                                        <SelectBox
                                            dataSource={this.state.dashboardData}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Select Field Name"
                                            defaultValue={0}
                                            value={this.state.fuelActivityVehicleId}
                                            displayExpr='vehicleNo'
                                            valueExpr='vehicleId'
                                            onSelectionChanged={this.handleOnFuelActivityVehChange}
                                            showClearButton={true}
                                            disabled={false}
                                            searchEnabled={true}
                                            width="100%"
                                        />
                                        {this.state.errors["fuelActivityVehicleId"].length > 0 && <span className="error invalid-feedback">{this.state.errors["fuelActivityVehicleId"]}</span>}
                                    </div>
                                </div>
                                <div className="pull-left" style={{ width: '150px', marginLeft: '7px' }}>
                                    <div className="form-group has-feedback" >
                                        <label>From Date </label>
                                        <DateBox
                                            type="datetime"
                                            className="form-control form-control-sm"
                                            name="fuelActivityStartDate"
                                            placeholder={DATEPICKER_FORMAT}
                                            displayFormat={DATEPICKER_FORMAT}
                                            showAnalogClock={false}
                                            useMaskBehavior={true}
                                            defaultValue={this.state.fuelActivityStartDate}
                                            value={this.state.fuelActivityStartDate}
                                            onValueChanged={this.handleFuelActivityStartDateChanged}
                                            width="100%"
                                            disabled={false}
                                            acceptCustomValue={false} />
                                        {this.state.errors["fuelActivityDateRangeError"].length > 0 && <span className="error invalid-feedback">{this.state.errors["fuelActivityDateRangeError"]}</span>}
                                    </div>
                                </div>
                                <div className="pull-left" style={{ width: '150px', marginLeft: '7px' }}>
                                    <div className="form-group">
                                        <label>To Date</label>
                                        <DateBox
                                            type="datetime"
                                            className="form-control form-control-sm"
                                            name="fuelActivityEndDate"
                                            placeholder={DATEPICKER_FORMAT}
                                            displayFormat={DATEPICKER_FORMAT}
                                            showAnalogClock={false}
                                            useMaskBehavior={true}
                                            defaultValue={this.state.fuelActivityEndDate}
                                            value={this.state.fuelActivityEndDate}
                                            onValueChanged={this.handleFuelActivityEndDateChanged}
                                            width="100%"
                                            disabled={false}
                                            acceptCustomValue={false}
                                        />
                                    </div>
                                </div>
                                <div className="pull-left" style={{ width: '150px', marginLeft: '7px', display: (this.state.fuelSensorList.length > 1 ? '' : 'none') }}>
                                    <div className="form-group">
                                        <label>Select Sensor</label>
                                        <SelectBox
                                            dataSource={this.state.fuelSensorList}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Select Sensor"
                                            defaultValue={0}
                                            value={this.state.fieldName}
                                            displayExpr='sensorName'
                                            valueExpr='fieldName'
                                            onSelectionChanged={this.handleOnFuelSensorChange}
                                            showClearButton={true}
                                            disabled={false}
                                            searchEnabled={true}
                                            width="100%"
                                        />
                                        {this.state.errors["fieldName"].length > 0 && <span className="error invalid-feedback">{this.state.errors["fieldName"]}</span>}
                                    </div>

                                </div>
                                <div className="pull-left" style={{ marginTop: '12px', marginLeft: '7px' }}>
                                    <div className="form-group">
                                        <button type="button" className="btn btn-success" onClick={this.handleOnSearchVehicleFuelActivity}> Go</button>
                                    </div>
                                </div>
                                <div className="pull-left" style={{ marginTop: '12px', marginLeft: '7px' }}>
                                    <div className="form-group">
                                        <button type="button" className="btn btn-success" onClick={this.handleHideFuelActivityDiv}> Back</button>
                                    </div>
                                </div>
                                <div className="pull-left" style={{ marginTop: '12px', marginLeft: '7px' }}>
                                    <div className="form-group">
                                        <input type="checkbox" checked={this.state.showIgnitionStatus} onChange={this.handleIgnitionEvent} name="showIgnitionStatus" style={{ backgroundColor: ANNTN_IGN_ON_BG }} />&nbsp; Engine Hours
                                    </div>
                                </div>
                                <div className="pull-left" style={{ marginTop: '12px', marginLeft: '7px' }}>
                                    <div className="form-group">
                                        <input type="checkbox" checked={this.state.showStopsStatus} onChange={this.handleStopsEvent} name="showStopsStatus" style={{ backgroundColor: ANNTN_STOPS_BG }} />&nbsp;Stops
                                    </div>
                                </div>
                                <div className="pull-left" style={{ marginTop: '12px', marginLeft: '7px' }}>
                                    <div className="form-group">
                                        <input type="checkbox" checked={this.state.showConnectionLossStatus} onChange={this.handleConnectionLossEvent} name="showConnectionLossStatus" style={{ backgroundColor: ANNTN_CONN_LOST_BG }} />&nbsp;Connection Loss
                                    </div>
                                </div>
                                <div className="clearfix"></div>
                            </div>

                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6" style={{ height: `88.5vh` }}>
                                    <div ref={this.mapRef} id="map" style={{ height: `100%`, width: `100%` }}></div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6" style={{ height: `88.5vh` }}>
                                    <div className="row">
                                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 text-right" style={{ display: !this.state.showFuelActivityDiv ? 'block' : 'none', paddingBottom: '10px' }}>
                                            <input type="text" className="form-control" name="searchValue" width="50px" placeholder="Search Vehicle" maxLength="50" title="Search" value={this.state.searchValue} onChange={this.handleInputChange} />
                                        </div>
                                    </div>
                                    <div style={{ display: !this.state.showFuelActivityDiv ? 'block' : 'none', height: '90%', width: `100%`, overflowY: 'scroll' }}>
                                        {
                                            this.state.filtereDashboardData != null && this.state.filtereDashboardData.map((item, i) => {
                                                let headerColor = this.renderStatusColor(item.hostStatus);
                                                var fuelPer = item.fuelLevelPct
                                                let bgcolor = '#2a8125';
                                                if (fuelPer <= 10) {
                                                    bgcolor = '#eb6d64';
                                                } else if (fuelPer > 10 && fuelPer < 20) {
                                                    bgcolor = '#e69500';
                                                }
                                                return <div className="activityCard" key={i} >
                                                    <div className="activityCardHeader" style={{ backgroundColor: headerColor }}>
                                                        <div style={{ width: '100%' }}>
                                                            <div className='pull-left'> <span>{item.vehicleNo} ({this.renderGridStatusCell(item.hostStatus)})</span></div>
                                                            <div className='pull-right'> <span onClick={(e) => { this.handleShowVehicleFuelDetails(item) }} title='View Chart' style={{ cursor: 'pointer' }} ><i className="fas fa-chart-line"></i>&nbsp;View Chart</span></div>
                                                            <div className='clearfix'></div>
                                                        </div>
                                                    </div>
                                                    <div className="activityCardBody" >
                                                        <div style={{ marginBottom: '7px' }}>
                                                            <div className='pull-left' style={{ width: '130px' }}>
                                                                <span title='Date'><i className="fas fa-calendar-alt"></i>&nbsp;{moment(item.deviceDateTime).format("DD-MM HH:mm")}</span>
                                                            </div>
                                                            <div className='pull-left'>
                                                                <span title='Fuel Level'><i className="fas fa-gas-pump"></i> {item.fuelLevel === -0.01 ? 'N/A' : item.fuelLevel} Ltr </span>
                                                                &nbsp;
                                                            </div>
                                                            <div className='pull-left' style={{ display: item.fuelLevelPct === 0 ? 'none' : '' }}>
                                                                <div className="fuelProgressbar" title={item.fuelLevelPct}>
                                                                    <div className="progress-bar progress-bar-striped" role="progressbar" style={{ backgroundColor: bgcolor, color: 'black', fontWeight: 'bold', width: item.fuelLevelPct }} aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>
                                                                </div>
                                                            </div>
                                                            <div className='clearfix'></div>
                                                        </div>

                                                        <div style={{ marginBottom: '7px' }}>
                                                            <i style={{ color: '#3db1dd' }} className="fas fa-map-pin"></i>&nbsp;<span title='Zoom' onClick={(e) => { this.handleZoomVehicle(item) }} style={{ cursor: 'pointer', textDecoration: 'underline', color: 'blue' }}>{item.address}</span><br></br>
                                                        </div>

                                                        <div>
                                                            <div className='pull-left'>
                                                                <span title='Last Refill' style={{ display: item.lastFuelFillOn != null || item.lastFuelFill != 0 ? '' : 'none', cursor: 'default' }}>
                                                                    <i style={{ color: 'green' }} className="fas fa-gas-pump"></i>&nbsp;{item.lastFuelFill} ({moment(item.lastFuelFillOn).format(DISPLAY_DATETIME_FORMAT)})
                                                                </span>
                                                            </div>
                                                            <div className='pull-left' style={{ marginLeft: '20px' }}>
                                                                <span title='Last Drain' style={{ display: item.lastFuelDrainOn != null || item.lastFuelDrain != 0 ? '' : 'none', cursor: 'default' }}>
                                                                    <i style={{ color: 'red' }} className="fas fa-gas-pump"></i>&nbsp;{item.lastFuelDrain} ({moment(item.lastFuelDrainOn).format(DISPLAY_DATETIME_FORMAT)})
                                                                </span>
                                                            </div>
                                                            <div className='clearfix'></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            })
                                        }
                                    </div>
                                    <div style={{ display: this.state.showFuelActivityDiv ? 'block' : 'none' }}>
                                        <ReactApexChart options={this.state.chartOptions} series={this.state.series} type='line' height={350} id='fuelChart' />
                                    </div>
                                    <div className="table-responsive" style={{ display: this.state.fuelActivityData != null && this.state.fuelActivityData.filter(f => f.fuelEvent !== null).length > 0 ? 'block' : 'none' }}>
                                        <div className='row' style={{ paddingLeft: '22px' }}>
                                            <p>Refill/Drain Event Data</p>
                                        </div>
                                        <div className="widget-container">
                                            <DataGrid
                                                dataSource={this.state.fuelActivityData != null ? this.state.fuelActivityData.filter(f => f.fuelEvent !== null) : []}
                                                id="fuelActivityGrid"
                                                className="dx-datagrid-height"
                                                //keyExpr="vehicleId"
                                                columnsAutoWidth={true}
                                                showColumnLines={true}
                                                showRowLines={true}
                                                showBorders={true}
                                                rowAlternationEnabled={false}
                                                allowColumnResizing={true}
                                                columnResizingMode='widget'
                                                style={{ fontSize: '9px' }}
                                                onRowPrepared={this.handleFuelGridRowPrepared}
                                            >
                                                <Grouping autoExpandAll={false} />
                                                <HeaderFilter visible={true} />
                                                <SearchPanel visible={false} highlightCaseSensitive={true} width={240} placeholder="Search..." />
                                                <Export fileName='Refill/DrainEventData' visible={false} enabled={false} allowExportSelectedData={false} />
                                                <GroupPanel visible={false} />
                                                <Paging defaultPageSize={10} />
                                                <Pager showPageSizeSelector={true} allowedPageSizes={[5, 10]} showInfo={true} visible={true} />
                                                <Column dataField="deviceDateTime" caption="Date" width={140} allowFiltering={true} allowSorting={true} />
                                                <Column dataField="fuelLevel" caption="Fuel" width={80} allowFiltering={true} allowSorting={true} />
                                                <Column dataField="" caption="Place" width={160} allowFiltering={true} allowSorting={true} cellRender={renderGridAddressCell} />
                                                {/* <Column dataField="hostStatus" caption="Status" width={80} allowFiltering={true} allowSorting={true} /> */}
                                                {/* <Column dataField="ignitionStatus" caption="IgnitionStatus" width={80} allowFiltering={true} allowSorting={true} /> */}
                                                {/*<Column dataField="fuelEvent" caption="Event" width={160} allowFiltering={true} allowSorting={true} />*/}
                                                {/* <Column dataField="fuelVolume" caption="Volume" width={160} allowFiltering={true} allowSorting={true} /> */}
                                            </DataGrid>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <LoadPanel
                    shadingColor="rgba(0,0,0,0.4)"
                    position={position}
                    visible={this.state.loadPanelVisible}
                    showIndicator={true}
                    shading={true}
                    showPane={true}
                    closeOnOutsideClick={false}
                />
            </Fragment >
        )
    }
}